import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";

export const postFoodMenuProfile = ({commit}, payload) => {
      
    axios.post('/foodMenus/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => { 

        commit('unsetOverlayState')

        if(res.data.status) {
            commit('setFoodMenuId', {id: res.data.id})    
        } else {
            alert(res.data.message)    
        }

    })
    .catch(error => {
        console.log(error)
        commit('setAlertBox', {title: 'message.error', message: 'Error: Please try again!!'})                
    })

}

export const fetchFoodMenuLists = ({commit}) => {
    
    axios.get('/customerPortal/catering/foodMenus.php', accessTokenInfo.accessTokenInfo())
    .then(res => { 
        commit('setFoodMenuList', res.data.response) 
    })
    .catch(error => {
        console.log(error)
    })

}

export const fetchFoodMenuProfileInfo = ({commit}, payload) => {
    axios.post('/customerPortal/foodMenusSingle.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => { 
        commit('unsetOverlayState')
        if(res.data.status) {
            commit('setFoodMenuProfileInfo', res.data.response[0])    
        }

    })
    .catch(error => {
        console.log(error)
    })

}


// WEBPACK FOOTER //
// ./src/store/modules/foodMenus/actions.js